export enum ENUM__coherence_mode {
  GAUSSIAN_BLUR = 'GAUSSIAN_BLUR',
  BOX_BLUR = 'BOX_BLUR',
  STAGED = 'STAGED',
}
